import moment from 'moment-timezone';

const timeZone = 'America/Bogota';

export const formatDate = (
  date: string | Date,
  format: DateFormat = 'DD/MM/YYYY'
) => {
  return date ? moment(date).tz(timeZone).format(format) : '';
};

export const formatDateForInput = (
  date: string | Date,
  format: DateFormat = 'DD/MM/YYYY'
) => {
  let dateToReturn = '';

  dateToReturn = moment(date).tz(timeZone).format();
  if (format === 'DD/MM/YYYY') {
    const [day] = dateToReturn.split('T');
    dateToReturn = day;
  } else if (format === 'DD/MM/YYYY hh:mm A') {
    dateToReturn = dateToReturn.slice(0, -9);
  }
  return dateToReturn;
};

export const getTimeHoursMinutes = (date: string, finalDate?: string) => {
  if (!date) return '-';
  const admissionDate = moment(date);
  const actualDate = finalDate ? moment(finalDate) : moment();
  const difference = moment.duration(actualDate.diff(admissionDate));
  const totalHours = difference.asHours();
  const hours = Math.floor(totalHours);
  const minutes = Math.round((totalHours - hours) * 60);
  return `${hours}h, ${minutes}min`;
};

export function formatToHour(time: string) {
  const [hour, minute] = time.split(':');
  let hourInt = parseInt(hour);
  const ampm = hourInt >= 12 ? 'PM' : 'AM';

  // Convert 24-hour format to 12-hour format
  hourInt = hourInt % 12;
  hourInt = hourInt ? hourInt : 12; // The hour '0' should display as '12'

  return `${hourInt}:${minute} ${ampm}`;
}

export const convertMinutesToHours = (duration: string, unit_time: string) => {
  if (!duration) return '-';
  const minutesToNumber = Number(duration);
  return `${minutesToNumber} ${unit_time?.[0]}`;
};

export const getDaysElapsed = (
  startDate: string | Date,
  endDate?: string | Date
) => {
  const start = new Date(startDate);
  const end = endDate ? new Date(endDate) : new Date();

  // Remove hours to avoid timezone errors
  start.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);

  const differenceMs = end.getTime() - start.getTime();
  const days = differenceMs / (1000 * 60 * 60 * 24); // ms -> days

  return days;
};

export const extractYearMonth = (date: string): string => {
  const [year, month] = date.split('-');
  return `${year}-${month}`;
};
